import React from "react";

const TeacherPagination = ({ pageNumber, totalPages, handlePageChange }) => {
  return (
    <div className="flex justify-between items-center mt-4">
      <button
        onClick={() => handlePageChange(pageNumber - 1)}
        className="px-3 py-1 bg-[#241763] text-white rounded"
        disabled={pageNumber === 1}
      >
        Previous
      </button>

      <div className="flex">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => handlePageChange(i + 1)}
            className={`px-3 py-1 mx-1 border rounded ${
              pageNumber === i + 1 ? "bg-[#241763] text-white" : "bg-gray-200"
            }`}
          >
            {i + 1}
          </button>
        ))}
      </div>

      <button
        onClick={() => handlePageChange(pageNumber + 1)}
        className="px-3 py-1 bg-[#241763] text-white rounded"
        disabled={pageNumber === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default TeacherPagination; 